import BaseService from './BaseService';
import ModelFactory from 'business/models/ModelFactory';
import {
  CrystalFilesUploadDTO,
  FileResponse,
  CrystalClient,
  CrystalDTO,
  CrystalImageDTO,
  CrystalTripDTO,
  CrystalFilesv4,
  CrystalWithResultDTO,
  ResponseDTO,
  ICrystalDTO,
  ResponseWithValueDTOOfCrystalTripAssignmentResponseDTO,
} from 'business/models/Models';
import { CrystalClientDTO } from 'components/Experiment/constants';

export default class CrystalService extends BaseService {
  async getCrystalDetails(id: number) {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient, false, true);
    const crystal: CrystalDTO = await crystalClient.getCrystalDetails(id);
    return crystal;
  }

  async getCrystalImage(id: number) {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient);
    const crystalImage: CrystalImageDTO = await crystalClient.getCrystalImage(id);
    return crystalImage;
  }

  async getAllUnassignedCrystals() {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient, false, true);
    const unassignedCrystals: CrystalDTO[] =
      await crystalClient.getAllUnassignedCrystals();
    return unassignedCrystals;
  }

  async uploadCrystalAttachments(filesDto: CrystalFilesUploadDTO) {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient);
    const crystalFiles: CrystalFilesv4[] = await crystalClient.uploadCrystalAttachments(
      filesDto,
    );
    return crystalFiles;
  }

  async downloadCrystalAttachment(fileId: number) {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient, false, true);
    const crystalFile: FileResponse = await crystalClient.downloadCrystalAttachment(
      fileId,
    );
    return crystalFile;
  }

  async toggleCrystalCollected(crystalId: number) {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient);
    const collected: boolean = await crystalClient.toggleCrystalDataCollected(crystalId);
    return collected;
  }
  async updateCrystal(crystal: CrystalDTO) {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient);
    const updatedCrystal: number = await crystalClient.updateCrystal(crystal);
    return updatedCrystal;
  }

  async DeleteCrystals(crystalIds: number[]): Promise<ResponseDTO> {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient, false, true);
    return await crystalClient.deleteCrystal(crystalIds);
  }

  async CreateCrystal(
    crystal: CrystalClientDTO,
    signal?: AbortSignal,
  ): Promise<CrystalDTO> {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient, false, true, signal);
    return await crystalClient.save(crystal);
  }

  async AssignCrystalsToTrip(
    crystalTrips: CrystalTripDTO[],
  ): Promise<ResponseWithValueDTOOfCrystalTripAssignmentResponseDTO> {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient, false, true);
    return await crystalClient.assignCrystalsToTrip(crystalTrips);
  }

  async getCrystalTripsByRegionId(regionId: number) {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient, false, true);
    return await crystalClient.getCrystalTrips(regionId);
  }

  async unAssignCrystal(crystalId: number) {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient);
    return await crystalClient.unAssignCrystal(crystalId);
  }

  async getCrystalPuckDewar(crystalId: number) {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient);
    return await crystalClient.getCrystalPuckDewar(crystalId);
  }

  async getCollectedCrystalsByTripId(tripId: number) {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient, false, true);
    return await crystalClient.getCollectedCrystalsByTripId(tripId);
  }

  async updateCrystalResult(crystalsWithResults: CrystalWithResultDTO[]) {
    const crystalClient: CrystalClient = ModelFactory(CrystalClient, false, true);
    return await crystalClient.updateCrystalResult(crystalsWithResults);
  }

  async GetCrystalInfoByRegion(regionId: number | string): Promise<ICrystalDTO[]> {
    const searchClient: CrystalClient = ModelFactory(CrystalClient, false, true);
    const data: ICrystalDTO[] = await searchClient.getCrystals(
      regionId as unknown as number,
    );
    return data;
  }
}
